import chunk from 'lodash/chunk';
import {
  FAIL_GET_DAILY_REPORT_ACQUISITION,
  REQUEST_GET_DAILY_REPORT_ACQUISITION,
  SUCCESS_GET_DAILY_REPORT_ACQUISITION,
} from '../../../actions/entities/dailyReport';
import {createReducer} from '../../utilities';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  const {response} = action;
  const chunkedArray = chunk(response.pastSeason, 6);
  const array = [...chunkedArray[1], ...chunkedArray[0]];
  return {
    ...state,
    data: {
      ...response,
      past: array,
    },
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_GET_DAILY_REPORT_ACQUISITION]: requestFetch,
  [SUCCESS_GET_DAILY_REPORT_ACQUISITION]: successFetch,
  [FAIL_GET_DAILY_REPORT_ACQUISITION]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/dailyReport/acquisition.js